import React from 'react';

const LogoAderant = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#0369A1"/>
    <path d="M14 16C14 14.8954 14.8954 14 16 14H32C33.1046 14 34 14.8954 34 16V32C34 33.1046 33.1046 34 32 34H16C14.8954 34 14 33.1046 14 32V16Z" fill="white"/>
    <path d="M18 18L24 24L30 18" stroke="#0369A1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 24L24 30L30 24" stroke="#0369A1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default LogoAderant;
